import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  private timers = new Map<string, BehaviorSubject<number>>();
  private timerSubscriptions = new Map<string, any>();

  startTimer(fieldName: string, duration: number) {
    if (this.timers.has(fieldName)) {
      this.timers.get(fieldName)?.next(duration);
    } else {
      const timerSubject = new BehaviorSubject<number>(duration);
      this.timers.set(fieldName, timerSubject);

      const subscription = timer(0, 1000)
        .pipe(map((elapsed) => duration - elapsed))
        .subscribe({
          next: (remaining) => {
            if (remaining <= 0) {
              timerSubject.next(0);
              if (this.timerSubscriptions.has(fieldName)) {
                this.timerSubscriptions.get(fieldName).unsubscribe();
                this.timerSubscriptions.delete(fieldName);
              }
              this.timers.delete(fieldName);
            } else {
              timerSubject.next(remaining);
            }
          },
        });

      this.timerSubscriptions.set(fieldName, subscription);
    }
  }

  resetTimer(fieldName: string, duration: number) {
    // Stop the current timer
    this.stopTimer(fieldName);

    // Restart the timer with the new duration
    this.startTimer(fieldName, duration);
  }

  stopTimer(fieldName: string) {
    // Unsubscribe from the timer if it exists
    if (this.timerSubscriptions.has(fieldName)) {
      this.timerSubscriptions.get(fieldName).unsubscribe();
      this.timerSubscriptions.delete(fieldName);
    }

    // Remove the timer from the map
    if (this.timers.has(fieldName)) {
      this.timers.delete(fieldName);
    }
  }

  getTimerObservable(fieldName: string) {
    return this.timers.get(fieldName)?.asObservable();
  }
}
